import http, { httpE, getTenantFromUrl } from "../helpers/http";

export const getTransactions = async (pageNumber, pageSize, payload, tenant = getTenantFromUrl()) => {
  let response;
  if (!tenant) {
    response = await http().post(
      `/Transaction/List?pageNumber=${pageNumber}&pageSize=${pageSize}`,
      payload
    );
  } else {
    response = await http(true).post(
      `/Organisation/get-organization-transaction?pageNumber=${pageNumber}&pageSize=${pageSize}`,
      payload
    );
  }
  return response.data;
};

export const getDashboardInfo = async (payload, tenant = getTenantFromUrl()) => {
  let response;
  if (!tenant) {
    response = await http().post("/Transaction/Dashboard", payload);
  } else {
    const cleanedParams = Object.entries(payload || {}).reduce((acc, [k, v]) => {
      if (v !== null && v !== undefined && v !== '') {
        acc[k] = v;
      }
      return acc;
    }, {});
    const queryParams = new URLSearchParams(cleanedParams).toString();
    response = await http(true).get(`/Organisation/get-organization-dashboard?${queryParams}`);
  }
  return response.data;
};
export const getGraphData = async (payload, tenant = getTenantFromUrl()) => {
  let response;
  if (!tenant) {
    response = await http().get("/Transaction/GetGraphData");
  } else {
    const cleanedParams = Object.entries(payload || {}).reduce((acc, [k, v]) => {
      if (v !== null && v !== undefined && v !== '') {
        acc[k] = v;
      }
      return acc;
    }, {});
    const queryParams = new URLSearchParams(cleanedParams).toString();
    response = await http(true).get(`/Organisation/get-organization-graph${queryParams ? `?${queryParams}` : ''}`);
  }
  return response.data;
};

export const downloadTransaction = async (payload, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return new Blob([]);
  }
  const response = await http().post("/Transaction/Download", payload, {
    responseType: "blob",
  });
  return response.data;
};

export const fetchAudit = async (payload, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, data: [], result: [], count: 0, totalPages: 0 };
  }
  const response = await http().post("/Audit/GetAuditLogsByRole", payload);
  return response.data;
};

export const getSplitSummary = async (params, tenant = getTenantFromUrl()) => {
  const query = new URLSearchParams(Object.entries(params || {}).filter(([_, v]) => v !== null && v !== undefined && v !== '')).toString();
  let response;
  if (!tenant) {
    response = await http().get(`/Transaction/GetSplitSummary/split/summary${query ? `?${query}` : ''}`);
  } else {
    response = await http(true).get(`/Organisation/get-organization-split-summary${query ? `?${query}` : ''}`);
  }
  return response.data;
};

export const getBeneficiarySummary = async (params, tenant = getTenantFromUrl()) => {
  const query = new URLSearchParams(Object.entries(params || {}).filter(([_, v]) => v !== null && v !== undefined && v !== '')).toString();
  let response;
  if (!tenant) {
    response = await http().get(`/Transaction/GetBeneficiarySummary/split/beneficiaries${query ? `?${query}` : ''}`);
  } else {
    response = await http(true).get(`/Organisation/get-organization-beneficiary-summary${query ? `?${query}` : ''}`);
  }
  return response.data;
};

export const getSplitTransactions = async (params, tenant = getTenantFromUrl()) => {
  const query = new URLSearchParams(Object.entries(params || {}).filter(([_, v]) => v !== null && v !== undefined && v !== '')).toString();
  let response;
  if (!tenant) {
    response = await http().get(`/Transaction/GetSplitTransactions/split/transactions${query ? `?${query}` : ''}`);
  } else {
    response = await http(true).get(`/Organisation/get-organization-split-transactions${query ? `?${query}` : ''}`);
  }
  return response.data;
};
export const exportSplitReport = async (params, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return new Blob([]);
  }
  const query = new URLSearchParams(Object.entries(params || {}).filter(([_, v]) => v !== null && v !== undefined && v !== '')).toString();
  const response = await httpE().get(`/export${query ? `?${query}` : ''}`, {
    responseType: 'blob'
  });
  return response.data;
};